import { DataBean } from "../../DataBean";


export class HealthAttentionCause extends DataBean {


    public async getHealthAttentionCauseCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthAttentionCauseCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}